import { CheckCircle, ErrorOutlined } from "@mui/icons-material";
import { Chip } from "@mui/material";

interface IGammaEvasionBadge {
  isComplete: boolean;
}

const GammaEvasionBadge: React.FC<IGammaEvasionBadge> = (
  props: IGammaEvasionBadge
) => {
  const { isComplete } = props;

  return (
    <Chip
      icon={isComplete ? <CheckCircle /> : <ErrorOutlined />}
      color={isComplete ? "success" : "error"}
      label={isComplete ? "Evaso" : "Non Evaso"}
    />
  );
};

export default GammaEvasionBadge;
